<template>
    <v-container fluid style="padding-top: 5px">

        <h3 class="title" v-text="selectedReport.user_obj_name" v-if="!$props.reportData.specialReport"></h3>
        <div class="special-report-select-container" v-if="$props.reportData.specialReport" dense>
            <v-autocomplete autocomplete="off" style="width: 300px;" class="report-select" label="Report Name" color="#c42111"  :value="$props.reportData.unique_id" :items="specialReportsList" item-text="unique_name" item-value="unique_id" dense outlined @change="changeSpecialReport" />
        </div>

        <v-menu>
            <template #activator="{ on: onMenu }">

                <span v-on="onMenu" style="margin-left: -35px; position: absolute;" />
                <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                    <template #activator="{ on: onTooltip }">
                        <v-btn class="mx-1 grid-button" title="Report Results Menu" fab dark x-small color="#c42111" v-on="{ ...onMenu, ...onTooltip }">
                            <v-icon dark>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <span>Report Results Menu</span>
                </v-tooltip>

            </template>
            <v-list>
                <v-list-item @click="showViewsFavsDetails = true">
                    <v-list-item-title><v-icon :size="'16'">mdi-content-save</v-icon>{{` Save Report View${$store.state.user.device_type ? ` (${$store.state.user.device_type})` : ''}`}}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showViewManagementClick">
                    <v-list-item-title><v-icon :size="'16'">mdi-monitor-multiple</v-icon> Report View Management</v-list-item-title>
                </v-list-item>
                <v-list-item @click="clearView">
                    <v-list-item-title><v-icon :size="'16'">mdi-layers-remove</v-icon> Clear View</v-list-item-title>
                </v-list-item>

                <v-list-group :value="false" no-action color="#ffffff" @click.stop="">
                    <template v-slot:activator>
                        <v-list-item-title><v-icon :size="'16'">mdi-format-letter-case</v-icon> Density</v-list-item-title>
                    </template>

                    <v-list-item @click="toggleGridSmallMode">
                        <v-icon class="density-check" :size="'16'" v-if="!gridSmallMode">mdi-check-bold</v-icon>
                        <v-list-item-title>Comfortable</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="toggleGridSmallMode">
                        <v-icon class="density-check" :size="'16'" v-if="gridSmallMode">mdi-check-bold</v-icon>
                        <v-list-item-title>Compact</v-list-item-title>
                    </v-list-item>
                </v-list-group>

                <v-list-item @click="showDialog = true" v-if="!$props.reportData.specialReport">
                    <v-list-item-title><v-icon :size="'16'">mdi-information-outline</v-icon> Report Documentation</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('showParams')" v-if="$props.reportData.specialReport">
                    <v-list-item-title><v-icon :size="'16'">mdi-information-outline</v-icon> Special Report Info</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportToExcelFile" v-if="!showChart">
                    <v-list-item-title><v-icon :size="'16'">mdi-file-excel</v-icon> Excel Data File</v-list-item-title>
                </v-list-item>
                <v-list-item @click="exportToCsvFile" v-if="!showChart">
                    <v-list-item-title><v-icon :size="'16'">mdi-file</v-icon> CSV File</v-list-item-title>
                </v-list-item>
                <v-list-item @click="toggleChart" v-if="!showChart">
                    <v-list-item-title><v-icon :size="'16'">mdi-chart-line</v-icon> Chart Data</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showRefreshSettings = true" v-if="!$props.reportData.specialReport && !$props.selectedReport.history" :disabled="!autoRefreshAllowed">
                    <v-list-item-title><v-icon :size="'16'" :disabled="!autoRefreshAllowed">mdi-refresh</v-icon> Auto Refresh Settings</v-list-item-title>
                </v-list-item>
                <v-list-item @click="showCreateWidgetModal = true" v-if="!$props.reportData.specialReport && !$props.selectedReport.history" :disabled="!autoRefreshAllowed">
                    <v-list-item-title><v-icon :size="'16'" :disabled="!autoRefreshAllowed">mdi-chart-bar</v-icon> Create Report Widget</v-list-item-title>
                </v-list-item>
                <v-list-item @click="toggleChart" v-if="showChart">
                    <v-list-item-title><v-icon :size="'16'">mdi-table-large</v-icon> Grid Data</v-list-item-title>
                </v-list-item>
                <v-list-item @click="chartPage = 0" v-if="showChart && (chartPage == 1)">
                    <v-list-item-title><v-icon :size="'16'">mdi-table-edit</v-icon> Edit Chart</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
            <template v-slot:activator="{ on }">
                <v-btn class="mx-1 grid-button" fab dark x-small color="#c42111" title="Report Notes" @click="$emit('notes')" v-on="on">
                    <v-icon>mdi-script-text</v-icon>
                </v-btn>
            </template>
            <span>Report Notes</span>
        </v-tooltip>

        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
            <template v-slot:activator="{ on }">
                <v-btn class="mx-1 ml-3 grid-button" title="Back" fab dark x-small color="#c42111" @click="$emit('back')" v-if="$props.selectedReport.history" v-on="on">
                    <v-icon dark>mdi-arrow-left</v-icon>
                </v-btn>
            </template>
            <span>Back</span>
        </v-tooltip>

        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
            <template v-slot:activator="{ on }">
                <v-btn class="mx-1 ml-3 grid-button" title="Back" fab dark x-small color="#c42111" @click="showReportParams = true" v-if="$props.selectedReport.history" v-on="on">
                    <v-icon dark>mdi-information-variant</v-icon>
                </v-btn>
            </template>
            <span>View Report Params</span>
        </v-tooltip>

        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
            <template v-slot:activator="{ on }">
                <v-btn class="mx-1 ml-3 grid-button" title="Force Refresh" fab dark x-small color="#c42111" @click="$emit('forceRefresh')" v-if="!$props.selectedReport.history && $props.reportData.cached" v-on="on">
                    <v-icon dark>mdi-table-refresh</v-icon>
                </v-btn>
            </template>
            <span>Force Refresh</span>
        </v-tooltip>

        <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
            <template v-slot:activator="{ on }">
                <v-btn class="mx-1 ml-3 grid-button" title="Fullscreen" fab dark x-small color="#c42111" @click="toggleFullscreen" v-if="!showChart" v-on="on">
                    <v-icon dark>mdi-fullscreen</v-icon>
                </v-btn>
            </template>
            <span>Fullscreen</span>
        </v-tooltip>

        <!-- <div class="refreshing-report-container" @click="refreshReportResults" v-if="refreshSettings.enabled"> -->
        <div class="refreshing-report-container" @click="refreshReportResults" :class="{show: refreshSettings.enabled}">
            <v-icon :class="{spin: refreshingNow}">mdi-refresh</v-icon>
            <span class="timer" v-text="autoRefreshTimeLeftPretty"></span>
        </div>


        <div class="view-select-container">
            <v-select class="view-select" outlined label="Report View" color="#c42111" :items="reportViewsFavs" v-model="selectedReportView" return-object item-text="view_name" @change="applyGridConfig">
                <template v-slot:item="{item}">
                    <span v-text="item.view_name" />
                    <span class="view-select-default-text" v-text="'DEFAULT'" v-if="item.default" />
                </template>
            </v-select>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-3 view-button" fab dark x-small color="#c42111" @click="showViewsFavsDetails = true" title="Save Report View" v-on="on">
                        <v-icon>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>Save Report View</span>
            </v-tooltip>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-2 view-button" fab dark x-small color="#c42111" @click="showViewManagementClick" title="Report View Management" v-on="on">
                        <v-icon>mdi-monitor-multiple</v-icon>
                    </v-btn>
                </template>
                <span>Report View Management</span>
            </v-tooltip>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-2 view-button" fab dark x-small color="#c42111" @click="clearView" title="Clear View" v-on="on">
                        <v-icon>mdi-layers-remove</v-icon>
                    </v-btn>
                </template>
                <span>Clear View</span>
            </v-tooltip>
        </div>


        <div class="data-container" :class="{hide: showChart}">
            <div id="ag-grid-report-results-container-fullscreen" :class="{history: $props.selectedReport.history}">
                <v-overlay id="ag-grid-report-results-container-fullscreen-overlay" v-if="($store.getters.fullscreenIsActive && ($store.getters.dialogIsActive || showConditionalFormattingEdit))" />
                <div id="ag-grid-container">
                    <ag-grid-vue :style="`width: 100%; height: ${showAggGrid ? 'calc(100% - 295px)' : '100%'};`" class="ag-theme-balham" :class="{'hide-grid': !showGrid}" v-if="showGrid"
                        :gridOptions="gridOptions"
                        :rowSelection="'multiple'"
                        :groupHeaders="true"
                        :headerHeight="50"
                        :scrollbarWidth="20"
                        :getRowHeight="getRowHeight"
                        :sendToClipboard="sendToClipboard"
                        :copyHeadersToClipboard="true">
                    </ag-grid-vue>

                    <ag-grid-vue style="height: 295px; flex: none; overflow-y: auto;" class="ag-theme-balham" v-if="showAggGrid"
                         :gridOptions="aggGridOptions"
                         :headerHeight="50"
                         :getRowHeight="20"
                         >
                    </ag-grid-vue>
                </div>
            </div>

            <span class="report-stat" v-html="`<b>${reportData.data.length}</b> results in <b>${reportData.runTime / 1000}</b> sec${$props.reportData.cached ? ' (cached)' : ''}`" v-if="!$props.selectedReport.history && !$props.selectedReport.specialReport" />
            <span class="report-stat" v-html="`<b>${reportData.data.length}</b> results. Run at ${formatHistoryTime($props.selectedReport.startTime)}`" v-if="$props.selectedReport.history" />

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn color="#c42111" x-small class="show-aggregates-button" :class="{'history': $props.selectedReport.history}" title="View Totals" @click="calculateAggregateData" v-on="on"><v-icon>mdi-sigma</v-icon></v-btn>
                </template>
                <span>View Totals</span>
            </v-tooltip>

        </div>

        <div class="chart-container" :class="{hide: !showChart}">
            <report-chart :reportData="reportData" :reportName="$props.selectedReport.user_obj_name" :runReportParams="$props.runReportParams" :runReportHumanText="$props.runReportHumanText" :transpose="chartTranspose" :datetimeColumn="datetimeColumn" :chartPage.sync="chartPage" :refreshChart="refreshChart" :viewChart="showChart" />
        </div>

        <docs-dialog v-model="showDialog" :title="$props.selectedReport.user_obj_name" :docs="reportData.docs" v-if="showDialog" />

        <v-dialog v-model="showRefreshSettings" max-width="80%" width="600px" persistent v-if="showRefreshSettings" @keydown="(k) => {k.key == 'Escape' ? showRefreshSettings = false : null}">
            <refresh-settings :refreshSettings="refreshSettings" @refreshSettingsChange="refreshSettingsChange" @cancel="showRefreshSettings = false" />
        </v-dialog>

        <v-dialog v-model="showConditionalFormattingEdit" max-width="80%" width="800px" persistent :attach="$store.state.fullscreenElement">
            <conditional-formatting-edit :conditionalFormattingEditColumn="conditionalFormattingEditColumn" @close="hideConditionalFormatting" @rules="applyAndSaveConditionalFormatting" v-if="showConditionalFormattingEdit" />
        </v-dialog>

        <v-dialog v-model="showViewManagement" max-width="80%" width="1400px" persistent v-if="showViewManagement" @keydown="(k) => {k.key == 'Escape' ? showViewManagement = false : null}">
            <view-management :viewType="`report|${$props.selectedReport.user_obj_name}`" :views="reportViews" :currentViewGridConfig="currentViewGridConfig" @close="showViewManagement = false" @open="(view) => {this.selectedReportView = view; applyGridConfig();}" @delete="handleViewDelete"></view-management>
        </v-dialog>

        <v-dialog v-model="showViewsFavsDetails" max-width="80%" width="550px" persistent v-if="showViewsFavsDetails" @keydown="(k) => {k.key == 'Escape' ? showViewsFavsDetails = false : null}">
            <views-favs-details :viewType="'report'" :selectedView="selectedReportView" :views="reportViews" @cancel="showViewsFavsDetails = false" @new="saveNewView" @overwrite="overwriteView"></views-favs-details>
        </v-dialog>

        <v-dialog v-model="showCreateWidgetModal" max-width="80%" width="500px" persistent v-if="showCreateWidgetModal" @keydown="(k) => {k.key == 'Escape' ? showCreateWidgetModal = false : null}">
            <create-widget :reportName="$props.selectedReport.user_obj_name" :reportWidgets="reportWidgets" @ok="createReportWidget" @cancel="showCreateWidgetModal = false"></create-widget>
        </v-dialog>

        <v-dialog v-model="showReportParams" max-width="80%" width="600px" v-if="showReportParams" @keydown="(k) => {k.key == 'Escape' ? showReportParams = false : null}">
            <v-card>
                <v-card-title>Report Params</v-card-title>
                <v-card-text>{{$props.runReportHumanText}}</v-card-text>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import { alarmPipeFilterParams, alarmDateFilterParams } from "@/components/Alarms/AlarmFuncs";
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-enterprise";
import ReportChart from '@/components/Reports/ReportChart';
import DocsDialog from '@/components/Reports/DocsDialog';
import CreateWidget from '@/components/Reports/CreateWidget';
import RefreshSettings from '@/components/Reports/RefreshSettings';
import ConditionalFormattingEdit from '@/components/Reports/ConditionalFormattingEdit';
import ViewManagement from "@/components/ViewManagement";
import ViewsFavsDetails from "@/components/ViewsFavsDetails";

export default {
    name: 'ReportResults',
    components: {
        'ag-grid-vue': AgGridVue,
        ReportChart,
        DocsDialog,
        RefreshSettings,
        ConditionalFormattingEdit,
        ViewManagement,
        ViewsFavsDetails,
        CreateWidget
    },
    props: ['selectedReport', 'reportDetails', 'reportData', 'runReportParams', 'runReportHumanText', 'specialReportsList'],
    data: () => ({
        showGrid: false,
        gridOptions: null,
        gridApi: null,
        showChart: false,
        gridSmallMode: false,
        chartTranspose: false,
        datetimeColumn: null,
        showDialog: false,
        showRefreshSettings: false,
        chartPage: 0,
        // filteredData: [],

        reportViews: [],
        selectedReportView: null,
        showViewsFavsDetails: false,
        showViewManagement: false,
        currentViewGridConfig: null,
        defaultColumnState: null,

        conditionalFormatting: [],
        conditionalFormattingRows: {},
        showConditionalFormattingEdit: false,
        conditionalFormattingEditColumn: null,
        specialReportName: '',

        refreshSettings: {
            enabled: false,
            refreshType: 'nochange',
            refreshIntervalMin: 10
        },
        clockTickIntervalFunc: null,
        autoRefreshIntervalFunc: null,
        autoRefreshTimeLeftSec: null,
        refreshingNow: false,
        originalDateRange: null,
        originalRunDate: TELSA.moment(TELSA.moment().format('YYYY-MM-DD')),
        refreshChart: 0,

        showCreateWidgetModal: false,
        reportWidgets: [],

        aggGridOptions: null,
        showAggGrid: false,

        showReportParams: false
    }),

    computed: {
        autoRefreshAllowed: function() {
            if(this.$props.reportDetails && this.$props.reportDetails.rpt_params.length) {
                for(let param of this.$props.reportDetails.rpt_params) {
                    if(param.rpt_param_type == "date_range") {
                        // Save the original date range values only if we havent saved them yet.
                        if(!this.originalDateRange) {
                            this.originalDateRange = param.selectedValue;
                        }
                        let endDate = TELSA.moment(param.selectedValue.split(' ')[1]);
                        if(endDate >= TELSA.moment.tz(this.$store.state.batchConfig.timezone)) {
                            return true;
                        }
                    }
                }
            }
            return false;
        },

        autoRefreshTimeLeftPretty: function() {
            if(this.autoRefreshTimeLeftSec == null) {
                return null;
            }
            return (TELSA.moment("1900-01-01 00:00:00").add(this.autoRefreshTimeLeftSec, 'seconds').format("mm:ss"));
        },

        gridRowPadding: function() {
            return (this.gridSmallMode ? '0px' : '8px');
        },

        reportViewsFavs: function() {
            return this.reportViews.length ? this.reportViews.filter(v => {return v.fav}) : [];
        },

        openAiLicense() {
            return this.$store.state.batchConfig.webapp_openai || false;
        }
    },

    methods: {
        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.$props.reportData.data;
            this.gridOptions.columnDefs = this.createColumnDefs(this.$props.reportData.cols, false);
            this.gridOptions.excelStyles = [{id: 'numberType', numberFormat: {format: '0'}}];
            this.gridOptions.getMainMenuItems = this.getMainMenuItems;
            this.gridOptions.suppressFieldDotNotation = true;
            this.gridOptions.suppressPropertyNamesCheck = true;
            this.searchForDatetimeColumn(this.$props.reportData.data[0]);

            let self = this;

            // Row level conditional formatting
            this.gridOptions.getRowStyle = ((params) => {
                if(self.conditionalFormattingRows[params.node.__objectId]) {
                    return { background: self.conditionalFormattingRows[params.node.__objectId].color, color: self.conditionalFormattingRows[params.node.__objectId].textColor };
                }
            });

            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();

                // Apply the user's default report settings. 
                let reportSettings = self.$store.state.batchConfig.webapp_settings.reports;
                self.customAutoSizeColumns();
                self.gridSmallMode = reportSettings.defaultDensity == "compact";
                
                self.defaultColumnState = self.gridOptions.columnApi.getColumnState();
                self.applyGridConfig();
                self.gridApi = self.gridOptions.api;
            }

            this.getRowHeight = function(params) {
                return (self.gridSmallMode ? 24 : 40);
            };

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    {
                        name: 'CSV Export',
                        action: function() {
                            self.exportToCsvFile();
                        }
                    },
                    {
                        name: 'Excel Export (.xlsx)',
                        action: function() {
                            self.exportToExcelFile();
                        }
                    },
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', self.$props.selectedReport.user_obj_name);
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function(cols, aggCols) {
            let self = this;
            let columnDefs = []
            for(let col of cols) {
                let just = 'center';
                if(col.justs == 'L') {
                    just = 'left';
                }
                else if(col.justs == 'R') {
                    just = 'right';
                }
                let filter = (col.type == "f" || col.type == "i") ? "number" : "text";
                let filterParams = alarmPipeFilterParams;
                let test = self.$props.reportData.data.length ? self.$props.reportData.data[0][col.name] : null;
                if((TELSA.moment(test, 'YYYY-MM-DD', true).isValid()) 
                    || (TELSA.moment(test, 'YYYY-MM-DD HH:mm:ss', true).isValid())
                    || (TELSA.moment(test, 'HH:mm:ss', true).isValid())
                    || (TELSA.moment(test, 'YYYY-MM-DD HH:mm:ssZ', true).isValid())
                    || (TELSA.moment(test, 'YYYY-WW', true).isValid())) {
                        filter = 'date';
                        filterParams = alarmDateFilterParams;
                }

                columnDefs.push({
                    headerName: col.name,
                    field: col.name,
                    filter: filter,
                    filterParams: filterParams,
                    headerTooltip: col.name,
                    width: self.calcColumnHeaderWidth(col.name),
                    hide: (col.width == 0 ? true : false),
                    sortable: true,
                    cellStyle: function(params) {
                        let cf = self.conditionalFormatting.find(cf => {
                            return cf.colId == col.name;
                        });
                        let conditionalFormattingRules = cf ? cf.rules : [];
                        let ruleToApply = self.getConditionalFormattingRuleToApply(conditionalFormattingRules, params.data[col.name]);
                        if(ruleToApply) {
                            if(ruleToApply.applyToRow) {
                                self.conditionalFormattingRows[params.node.__objectId] = ruleToApply;
                            }
                            return {'padding-top': `${aggCols ? '0px' : self.gridRowPadding}`, 'text-align': just, 'background-color': ruleToApply.color, 'color': ruleToApply.textColor}
                        }
                        else {
                            return {'padding-top': `${aggCols ? '0px' : self.gridRowPadding}`, 'text-align': just}
                        }
                    },
                    valueGetter: function(params) {
                        // This is to get agGrid to sort numbers correctly
                        if(!isNaN(Number(String(params.data[col.name]).replace(/,/g, ''))) && params.data[col.name] !== "") {
                            // check further to make sure its actually a number
                            let regex = /,\d{4,}$/gm;
                            try {
                                if(!regex.test(String(params.data[col.name]))) {
                                    return Number(String(params.data[col.name]).replace(/,/g, ''));
                                }
                            }
                            catch {
                                return Number(String(params.data[col.name]).replace(/,/g, ''));
                            }
                        }
                        return params.data[col.name];
                    },
                    conditionalFormattingAllowed: (col.type == "f" || col.type == "i"),
                    cellClass: (col.type == "f" || col.type == "i") ? 'numberType' : ''
                })
            }
            return columnDefs;
        },

        customAutoSizeColumns: function() {
            let self = this;
            this.gridOptions.columnApi.getAllColumns().forEach(function (column) {
                let width = column.actualWidth;
                self.gridOptions.columnApi.autoSizeColumn(column.colId, true);
                let newWidth = column.actualWidth;
                if(newWidth < width) {
                    self.gridOptions.columnApi.setColumnWidth(column.colId, width);
                }
            });
        },

        calcColumnHeaderWidth: function(colHeader) {
            let parts = colHeader.split(' ');
            let maxPart = 0;
            for(let part of parts) {
                if(part.length > maxPart) {
                    maxPart = part.length;
                }
            }
            let charPixels = parts.length > 4 ? 15 : 11;
            let addition = (parts.length > 3 && maxPart < 7) ? 45 : 30;
            let sortAddition = (this.reportData.sorts.includes(colHeader) ? 20 : 0);
            let width = addition + (charPixels * maxPart) + sortAddition;
            return width;
        },

        getMainMenuItems: function(params) {
            console.log(params);
            let items = params.defaultItems;
            let self = this;
            if(params.column.colDef.conditionalFormattingAllowed) {
                items.push({
                    name: 'Conditional Formatting',
                    action: function () {
                        self.editConditionalFormatting(params);
                    },
                });
            }
            return items;
        },

        editConditionalFormatting: function(params) {
            let cf = this.conditionalFormatting.find(cf => {
                return cf.colId == params.column.colId;
            });
            params.column.colDef.conditionalFormattingRules = cf ? cf.rules : [];
            this.conditionalFormattingEditColumn = params.column;
            this.showConditionalFormattingEdit = true;
        },

        hideConditionalFormatting: function() {
            this.showConditionalFormattingEdit = false;
            this.conditionalFormattingEditColumn = null;
        },

        getConditionalFormattingRuleToApply: function(conditionalFormattingRules, value) {
            let ruleToApply = null;
            let fValue = String(value).replace(/,/g, '');
            for (let rule of conditionalFormattingRules) {
                if(rule.condition == 'lt' && Number(fValue) < Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'lte' && Number(fValue) <= Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'eq' && Number(fValue) == Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'gt' && Number(fValue) > Number(rule.value)) {
                    ruleToApply = rule;
                }
                else if(rule.condition == 'gte' && Number(fValue) >= Number(rule.value)) {
                    ruleToApply = rule;
                }

                if(ruleToApply && ruleToApply.stopIfTrue) {
                    break;
                }
            }
            return ruleToApply;
        },

        applyAndSaveConditionalFormatting: function(rules) {
            let colId = this.conditionalFormattingEditColumn.colId;

            // Update the Conditional Formatting list
            let cfMod = this.conditionalFormatting.find(cf => {
                return cf.colId == colId;
            });
            if(cfMod) {
                cfMod.rules = rules;
            }
            else {
                this.conditionalFormatting.push({
                    colId: colId,
                    rules: rules
                });
            }
            this.conditionalFormattingRows = {};

            // Hide conditional formatting edit window and reset edit obj variable
            this.showConditionalFormattingEdit = false;
            this.conditionalFormattingEditColumn = null;


            // Rebuild grid to apply the conditional formatting
            this.gridOptions.api.redrawRows();
        },

        exportToExcelFile: function() {
            let convertToPercentForExport = (this.$store.state.batchConfig.webapp_settings.reports && this.$store.state.batchConfig.webapp_settings.reports.convertToPercentForExport);
            let cellValueFunc = function(params) {
                if(convertToPercentForExport) {
                    return (params.column.colId.slice(-1) == '%') ? (String(params.value) + '%') : params.value;
                }
                return params.value;
            };

            let params = {
                fileName: `${this.selectedReport.user_obj_name}_${TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD')}`,
                sheetName: 'data',
                processCellCallback: cellValueFunc
            };
            this.gridOptions.api.exportDataAsExcel(params);
        },
        exportToCsvFile: function() {
            let convertToPercentForExport = (this.$store.state.batchConfig.webapp_settings.reports && this.$store.state.batchConfig.webapp_settings.reports.convertToPercentForExport);
            let cellValueFunc = function(params) {
                if(convertToPercentForExport) {
                    return (params.column.colId.slice(-1) == '%') ? (String(params.value) + '%') : params.value;
                }
                return params.value;
            };

            let params = {
                fileName: `${this.selectedReport.user_obj_name}_${TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD')}`,
                sheetName: 'data',
                processCellCallback: cellValueFunc
            };
            this.gridOptions.api.exportDataAsCsv(params);
        },

        toggleChart: function() {
            this.showChart = !this.showChart;
            if(!this.showChart) {
                return;
            }

            let filteredData = []
            this.gridOptions.api.forEachNodeAfterFilterAndSort((node, idx) => {
                filteredData.push(node.data);
            });
            this.$props.reportData.data = filteredData;
            
            this.chartTranspose = this.datetimeColumn ? true : false;
            if(!this.chartTranspose) {
                this.$store.commit('showConfirmModal', {
                    title: 'Warning',
                    message: `No datetime columns were found. Chart data will not be over time.`,
                    type: 'warning',
                    hideCancel: true,
                    confirmAction: function(){return;}
                });
            }
        },

        searchForDatetimeColumn: function(dataRowObj) {
            if(dataRowObj) {
                for(const key of Object.keys(dataRowObj)) {
                    if((TELSA.moment(dataRowObj[key], 'YYYY-MM-DD', true).isValid()) 
                        || (TELSA.moment(dataRowObj[key], 'YYYY-MM-DD HH:mm:ss', true).isValid())
                        || (TELSA.moment(dataRowObj[key], 'HH:mm:ss', true).isValid())
                        || (TELSA.moment(dataRowObj[key], 'YYYY-MM-DD HH:mm:ssZ', true).isValid())
                        || (TELSA.moment(dataRowObj[key], 'YYYY-WW', true).isValid())) {
                        this.datetimeColumn = key;
                        break;
                    }
                }
            }
        },

        formatHistoryTime: function(time) {
            return TELSA.moment(time).format('YYYY-MM-DD HH:mm:ss');
        },

        changeSpecialReport: function(val) {
            this.$emit('specialReportChange', val);
        },

        refreshSettingsChange: function(refreshSettings) {
            this.refreshSettings = refreshSettings;
            this.showRefreshSettings = false;

            clearInterval(this.clockTickIntervalFunc);
            clearInterval(this.autoRefreshIntervalFunc);
            if(!this.refreshSettings.enabled) {
                return;
            }
            //let refreshIntervalSec = Math.round(this.refreshSettings.refreshIntervalMin * 60);
            this.autoRefreshTimeLeftSec = Math.round(this.refreshSettings.refreshIntervalMin * 60);

            this.setupAutoRefreshIntervalFunc();

            let self = this;
            this.clockTickIntervalFunc = setInterval(function() {
                if(self.autoRefreshTimeLeftSec > 0) {
                    self.autoRefreshTimeLeftSec = (self.autoRefreshTimeLeftSec - 1);
                }
            }, 1000);
        },

        setupAutoRefreshIntervalFunc: function() {
            let refreshIntervalSec = Math.round(this.refreshSettings.refreshIntervalMin * 60);
            let self = this;
            clearInterval(this.autoRefreshIntervalFunc);
            this.autoRefreshIntervalFunc = setInterval(function() {
                self.refreshReportResults();
            }, (refreshIntervalSec * 1000));
        },

        refreshReportResults: function() {
            this.refreshingNow = true;
            clearInterval(this.autoRefreshIntervalFunc);
            this.autoRefreshTimeLeftSec = 0; // This normally should already be 0 except when they manually refreshed. Then we need to set it to 0 manually.

            let dateParam;
            for(let param of this.$props.reportDetails.rpt_params) {
                if(param.rpt_param_type == "date_range") {
                    dateParam = param;
                    break;
                }
            }

            // Code to update the date Param
            if(this.refreshSettings.refreshType == "nochange") {
                // Do nothing to the date params
            }
            else {
                let originalStartDate = TELSA.moment(this.originalDateRange.split(' ')[0]);
                let originalEndDate = TELSA.moment(this.originalDateRange.split(' ')[1]);
                let todayDate = TELSA.moment(TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD'));
                let daysPast = todayDate.diff(this.originalRunDate, 'days');
                let newEndDate = originalEndDate.clone().add(daysPast, 'days');
                let newStartDate = originalStartDate.clone().add(daysPast, 'days');

                if(this.refreshSettings.refreshType == "enddate") {
                    dateParam.selectedValue = `${originalStartDate.format('YYYY-MM-DD')} ${newEndDate.format('YYYY-MM-DD')}`;
                    dateParam.humanText = `${originalStartDate.format('YYYY-MM-DD')} to ${newEndDate.add(-1, 'days').format('YYYY-MM-DD')}`;
                }
                else if(this.refreshSettings.refreshType == "window") {
                    dateParam.selectedValue = `${newStartDate.format('YYYY-MM-DD')} ${newEndDate.format('YYYY-MM-DD')}`;
                    dateParam.humanText = `${newStartDate.format('YYYY-MM-DD')} to ${newEndDate.add(-1, 'days').format('YYYY-MM-DD')}`;
                }
            }

            // Code to setup and run the report again.
            let paramArr = [];
            let humanTextArr = [];
            for(let param of this.$props.reportDetails.rpt_params) {
                paramArr.push(param.selectedValue);
                humanTextArr.push(param.humanText);
            }

            //run report
            let route = (TELSA.apiHost + "report/run");
            let startTimestamp = Date.now();
            this.$http.post(route, {args: {report: this.$props.selectedReport.user_obj_name, params: paramArr, humanParams: humanTextArr, noCache: true}}).then(response => {
                let result = response.body;
                console.log('RESULT', result);

                if(result.file_name) {
                    this.$emit('autoRefreshFile', result);
                }
                else {
                    this.$props.reportData.data = result.data.data;
                    this.gridOptions.rowData = this.$props.reportData.data;
                    this.gridOptions.api.setRowData(this.$props.reportData.data);

                    this.applyGridConfig();
                    let filteredData = []
                    this.gridOptions.api.forEachNodeAfterFilterAndSort((node, idx) => {
                        filteredData.push(node.data);
                    });
                    this.$props.reportData.data = filteredData;


                    this.$props.reportData.runTime = (Date.now() - startTimestamp);
                    if(this.showChart) { // This is what triggers the chart to reload the new data.
                        this.refreshChart++;
                    }
                }

                this.refreshingNow = false;
                this.setupAutoRefreshIntervalFunc();
                this.autoRefreshTimeLeftSec = Math.round(this.refreshSettings.refreshIntervalMin * 60);
            });
        },


        toggleFullscreen: function() {
            document.getElementById('ag-grid-report-results-container-fullscreen').webkitRequestFullscreen();
        },

        toggleGridSmallMode: function() {
            this.gridSmallMode = !this.gridSmallMode;
            this.gridOptions.api.resetRowHeights();
            this.gridOptions.api.redrawRows();
        },

        sendToClipboard: function(params) {
            navigator.clipboard.writeText(params.data);
        },

        applyGridConfig: function() {
            // If there is no report view then we're done.
            if(this.selectedReportView) {
                if(!this.gridOptions.columnApi.setColumnState(this.selectedReportView.view_grid_config.gridData)) {
                    // A new column exists that isn't in the saved grid config
                    for(let c of this.$props.reportData.cols) {
                        if(!this.selectedReportView.view_grid_config.gridData.some(dataCol => {
                            return c.name == dataCol.colId;
                        })) {
                            this.gridOptions.columnApi.setColumnVisible(c.name, true);
                        }
                    }
                }
                this.gridOptions.api.setFilterModel(this.selectedReportView.view_grid_config.filterData);
                this.gridOptions.api.setSortModel(this.selectedReportView.view_grid_config.sortData);
                this.gridSmallMode = this.selectedReportView.view_grid_config.gridSmallMode ? this.selectedReportView.view_grid_config.gridSmallMode : false;
                this.conditionalFormatting = JSON.parse(JSON.stringify(this.selectedReportView.view_grid_config.conditionalFormatting ? this.selectedReportView.view_grid_config.conditionalFormatting : []));
            }
            else {
                // If the sorts option is defined then apply 'report-file-defined' default sorts
                let sortModel = [];
                for(let sort of this.reportData.sorts) {
                    let sortType = "asc";
                    try {
                        sortType = this.reportData.cols.find(c => c.name == sort).sort_order == 1 ? "desc" : "asc";
                    }
                    catch(error) {
                        // Do nothing
                    }
                    sortModel.push({
                        colId: sort,
                        sort: sortType
                    });
                }
                this.gridOptions.api.setSortModel(sortModel);
            }

            // we need to trigger the UI to change to compact/comfortable mode.
            this.gridOptions.api.resetRowHeights();
            this.gridOptions.api.redrawRows();
            TELSA.loading(false);
        },

        getReportViews: function() {
            let route = `${TELSA.apiHost}views/list/report|${encodeURIComponent(encodeURIComponent(this.$props.selectedReport.user_obj_name))}`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.reportViews = results;
                if(this.$props.reportData.specialReport) {
                    let viewId = this.$props.selectedReport.orig_thres_info.webapp_view_id;
                    this.selectedReportView = viewId ? this.reportViews.find(rv => rv.view_id == viewId) : null;
                }
                else {
                    this.selectedReportView = this.reportViewsFavs.find(v => {return v.default}) || (this.reportViewsFavs.length ? this.reportViewsFavs[0] : null);
                }

                // Set initial conditional formatting
                if(this.selectedReportView && this.selectedReportView.view_grid_config.conditionalFormatting) {
                    this.conditionalFormatting = JSON.parse(JSON.stringify(this.selectedReportView.view_grid_config.conditionalFormatting));
                }
            });
        },

        showViewManagementClick: function() {
            let obj = {
                gridData: this.gridOptions.columnApi.getColumnState(),
                filterData: this.gridOptions.api.getFilterModel(),
                sortData: this.gridOptions.api.getSortModel(),
                gridSmallMode: this.gridSmallMode,
                conditionalFormatting: this.conditionalFormatting
            }
            this.currentViewGridConfig = obj;
            this.showViewManagement = true;
        },


        overwriteView: function() {
            TELSA.loading(true);
            this.showViewsFavsDetails = false;
            this.selectedReportView.view_grid_config = {
                gridData: this.gridOptions.columnApi.getColumnState(),
                filterData: this.gridOptions.api.getFilterModel(),
                sortData: this.gridOptions.api.getSortModel(),
                gridSmallMode: this.gridSmallMode,
                conditionalFormatting: this.conditionalFormatting
            };
            let route = `${TELSA.apiHost}views/edit`;
            return this.$http.post(route, {args: {view: this.selectedReportView, old_view_name: this.selectedReportView.view_name}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },
        saveNewView: function(newView) {
            TELSA.loading(true);
            this.showViewsFavsDetails = false;

            // If they set this new view as the new default, then we have to unset the old one.
            if(newView.viewDefault) {
                for(let view of this.reportViews) {
                    view.default = false;
                }    
            }
            this.selectedReportView = {
                user_id: this.$store.state.user.user_id,
                view_type: `report|${this.$props.selectedReport.user_obj_name}`,
                view_name: newView.viewName,
                view_device_type: this.$store.state.user.device_type,
                view_public: newView.viewPublic,
                view_grid_config: {
                    gridData: this.gridOptions.columnApi.getColumnState(),
                    filterData: this.gridOptions.api.getFilterModel(),
                    sortData: this.gridOptions.api.getSortModel(),
                    gridSmallMode: this.gridSmallMode,
                    conditionalFormatting: this.conditionalFormatting
                },
                fav: true,
                default: newView.viewDefault
            };
            this.reportViews.push(this.selectedReportView);
            this.reportViews.sort((a,b) => (a.view_name.toLowerCase() > b.view_name.toLowerCase()) ? 1 : ((b.view_name.toLowerCase() > a.view_name.toLowerCase()) ? -1 : 0));
            let route = `${TELSA.apiHost}views/add`;
            return this.$http.post(route, {args: {view: this.selectedReportView}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
            });
        },
        saveViewsFavs: function() {
            let reportViewsFavs = [];
            for(let view of this.reportViews) {
                if(view.fav) {
                    reportViewsFavs.push({
                        user_id: view.user_id,
                        view_name: view.view_name,
                        default: view.default
                    });
                }
            }

            let route = `${TELSA.apiHost}views/favs`;
            return this.$http.post(route, {args: {view_type: `report|${this.$props.selectedReport.user_obj_name}`, views_favs: reportViewsFavs}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },
        handleViewDelete: function(view) {
            if(view == this.selectedReportView) {
                this.selectedReportView = null;
            }
        },

        clearView: function() {
            this.gridOptions.columnApi.setColumnState(this.defaultColumnState);
            this.gridOptions.api.setFilterModel(null);
            this.gridOptions.api.setSortModel(null);
            this.selectedReportView = null;
            this.conditionalFormatting = [];
            // Rebuild grid to apply the removal of conditional formatting
            this.gridOptions.api.redrawRows();
        },

        getReportWidgets: function() {
            let route = `${TELSA.apiHost}report/widgets/list`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.reportWidgets = results;
            });
        },

        createReportWidget: function(widgetObj) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}report/widgets/add`;
            let reportWidget = {
                user_id: this.$store.state.user.user_id,
                widget_name: widgetObj.name, 
                widget_public: widgetObj.public, 
                report_name: this.$props.selectedReport.user_obj_name,
                original_run_date: this.originalRunDate.format("YYYY-MM-DD"),
                report_params: this.$props.reportDetails.rpt_params
                // report_params: this.$props.runReportParams,
                // human_params: this.$props.runReportHumanText
            };

            // We need to remove the rpt_param_values from the report_param object because it can contain very large
            // lists(i.e. entire site list) and needlessly greatly increase the data size of the widgets.
            for(let param of reportWidget.report_params) {
                if(param.rpt_param_values) {
                    delete param.rpt_param_values;
                }
            }
            
            return this.$http.post(route, {args: {reportWidget: reportWidget}}).then(response => {
                let result = response.body;
                this.showCreateWidgetModal = false;
                this.reportWidgets.push(reportWidget);
                TELSA.loading(false);
            });
        },

        calculateAggregateData: function() {
            if(this.showAggGrid) {
                this.showAggGrid = false;
                return;
            }

            let filteredData = []
            this.gridOptions.api.forEachNodeAfterFilterAndSort((node, idx) => {
                filteredData.push(node.data);
            });

            if(!filteredData.length) {
                return;
            }

            TELSA.loading(true);

            let numericCols = this.$props.reportData.cols.filter(c => c.type == "f");
            for(let numericCol of numericCols) {
                let colKey = numericCol.name;
                let dataArray = filteredData.map(d => Number(d[colKey].replace(/,/g, '')));
                let dataArrayLength = dataArray.length;
                //let sortedDataArray = dataArray.sort((a,b) => Number(a[colKey]) - Number(b[colKey]));
                let sortedDataArray = dataArray.sort((a,b) => (a - b));
                numericCol.aggMinimum = sortedDataArray[0];
                numericCol.agg25 = sortedDataArray[Math.floor(dataArrayLength / 4)];
                numericCol.aggMedian = sortedDataArray[Math.floor(dataArrayLength / 2)];
                numericCol.agg75 = sortedDataArray[Math.floor(dataArrayLength * 0.75)];
                numericCol.aggMaximum = sortedDataArray[dataArrayLength - 1];
                numericCol.aggTotal = sortedDataArray.reduce((a, b) => a + b, 0);
                numericCol.aggMean = (numericCol.aggTotal / dataArrayLength);
                numericCol.aggStandardDeviation = Math.sqrt(sortedDataArray.map(x => Math.pow(x - numericCol.aggMean, 2)).reduce((a, b) => a + b) / dataArrayLength);
                // Rounding to nearest tenth when needed.
                numericCol.agg25 = (Math.round(numericCol.agg25 * 1000) / 1000);
                numericCol.agg75 = (Math.round(numericCol.agg75 * 1000) / 1000);
                numericCol.aggMean = (Math.round(numericCol.aggMean * 1000) / 1000);
                numericCol.aggStandardDeviation = (Math.round(numericCol.aggStandardDeviation * 1000) / 1000);
                numericCol.aggTotal = (Math.round(numericCol.aggTotal * 1000) / 1000);
            }

            //let labelCol = this.$props.reportData.cols[0].name;
            let aggRows = [
                {text: 'Minimum', value: 'aggMinimum'},
                {text: '25%', value: 'agg25'},
                {text: 'Median', value: 'aggMedian'},
                {text: '75%', value: 'agg75'},
                {text: 'Maximum', value: 'aggMaximum'},
                {text: 'Mean', value: 'aggMean'},
                {text: 'Std Dev', value: 'aggStandardDeviation'},
                {text: 'Total', value: 'aggTotal'},
            ];
            let aggDataRows = [];
            for(let aggRow of aggRows) {
                let aggData = {};
                for(let [idx, col] of this.$props.reportData.cols.entries()) {
                    let numericCol = numericCols.find(c => col.name == c.name);
                    if(idx == 0) {
                        aggData[col.name] = aggRow.text;
                    }
                    else if(numericCol) {
                        aggData[col.name] = numericCol[aggRow.value].toString();
                    }
                    else {
                        aggData[col.name] = "";
                    }
                }
                aggDataRows.push(aggData);
            }

            this.aggGridOptions = {};
            this.aggGridOptions.rowData = aggDataRows;
            this.aggGridOptions.columnDefs = this.createColumnDefs(this.$props.reportData.cols, true);
            //this.aggGridOptions.getMainMenuItems = this.getMainMenuItems;
            this.aggGridOptions.suppressFieldDotNotation = true;

            this.aggGridOptions.alignedGrids = [this.gridOptions];
            this.gridOptions.alignedGrids = [this.aggGridOptions];
            this.showAggGrid = true;
            TELSA.loading(false);
        }
    },

    mounted() {
        TELSA.loading(true);
        this.getReportViews().then(r => {
            this.getReportWidgets().then(rr => {
                this.reportData.sorts = this.reportData.sorts || [];
                this.buildAgGrid();
            });
        });
    },

    destroyed() {
        clearInterval(this.autoRefreshIntervalFunc);
        clearInterval(this.clockTickIntervalFunc);
    },

  
};
</script>

<style scoped>

    .view-select-container {
        position: relative;
        display: inline-block;
        /* width: 400px; */
        margin-left: calc(50% - (550px / 1));
        text-align: center;
        height: 40px;
    }
    .view-select {
        width: 250px;
        display: inline-block;
    }
    .view-select-container .view-button {
        display: initial;
    }

    @media(max-width: 1600px) {
        .view-select-container {
            width: 400px;
            margin-left: 20px;
        }
        .view-select {
            width: 250px;
        }
    }
    @media(max-width: 1000px) {
        .view-select-container {
            width: 320px;
            float: right;
        }
        .view-select {
            width: 180px;
        }
        .view-select-container .view-button {
            display: none;
        }
    }
    @media(max-width: 900px) {
        .view-select-container {
            width: 180px;
            float: right;
        }
        .view-select {
            width: 180px;
        }
        .view-select-container .view-button {
            display: none;
        }
    }
    /* @media(max-width: 900px) {
        .view-select-container {
            width: 80px;
            float: right;
            margin-left: 1px;
        }
        .view-select {
            width: 80px;
        }
    } */

    .view-select-default-text {
        color: yellow;
        position: absolute;
        right: 20px;
        text-align: right;
        font-size: 11px;
        font-weight: bold;
    }

    .density-check {
        margin-left: -35px;
        margin-right: 18px;
    }

    #ag-grid-report-results-container-fullscreen {
        /* height: calc(100vh - 292px); */
        height: calc(100vh - 245px);
    }
    #ag-grid-report-results-container-fullscreen.history {
        height: calc(100vh - 184px);
    }

    #ag-grid-container {
        height: 100%;
    }
    #ag-grid-container.history {
        height: 100%;
    }

    .title {
        color: #ffffff;
        display: inline-block;
        margin-bottom: 1em;
    }

    .special-report-select-container {
        display: inline-block;
        margin-bottom: -15px;
        margin-top: -5px;
    }

    .report-stat {
        color: #ffffff;
        display: block;
        font-size: 10pt;
    }
    .report-stat.cache-bust-link {
        /* color: #0000FF; */
        color: #ffffff;
        text-decoration: underline;
        cursor: pointer;
        display: inline-block;
        margin-left: 1em;;
    }

    .grid-button {
        margin-bottom: 0.5em;
    }

    .data-container {
        display: initial;
        height: initial;
        transition: all 0.3s linear;
    }
    .data-container.hide {
        display: none;
        height: 0;
        transition: all 0.3s linear;
    }

    .chart-container {
        display: initial;
        height: initial;
        transition: all 0.3s linear;
    }
    .chart-container.hide {
        display: none;
        height: 0;
        transition: all 0.3s linear;
    }

    .refreshing-report-container {
        /* display: inline-block; */
        display: none;
        margin-left: 1em;
        border: rgba(0, 0, 0, 0.2) solid 1px;
        background-color: rgba(255, 255, 255, 0.15);
        padding: 5px 5px 4px 5px;
        border-radius: 3px;
        cursor: pointer;
    }
    .refreshing-report-container.show {
        display: inline-block;
    }
    .refreshing-report-container:hover {
        background-color: rgba(255, 255, 255, 0.35);
    }
    .refreshing-report-container .timer {
        vertical-align: text-top;
        font-weight: 500;
    }
    .refreshing-report-container i.spin {
        animation-name: spin;
        animation-duration: 1000ms;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }

    @keyframes spin {
        from {
            transform:rotate(0deg);
        }
        to {
            transform:rotate(360deg);
        }
    }

    .show-aggregates-button {
        position: absolute;
        right: 16px;
        bottom: 5px;
        height: 25px !important;
    }
    .show-aggregates-button.history {
        right: 15px;
        bottom: 0px;
    }

    @keyframes rainbow-border {
        0% { border-color: red; }
        20% { border-color: orange; }
        40% { border-color: yellow; }
        60% { border-color: green; }
        80% { border-color: blue; }
        100% { border-color: purple; }
    }

    @keyframes glow-gradient {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
    }

</style>


<style>
    .ag-row:hover {
        background-color: #c8e6c9;
    }

    /* For column header word wrap */
    .ag-header-cell-text {
        white-space: initial !important;
    }

    .hide-grid {
        display: none;
    }

</style>
